import { useState, useEffect } from "react";

/**
 * Hook pour détecter les media queries responsive
 *
 * Usage:
 * const isMobile = useMediaQuery('(max-width: 768px)');
 * const isTablet = useMediaQuery('(min-width: 769px) and (max-width: 1023px)');
 * const isDesktop = useMediaQuery('(min-width: 1024px)');
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    // Vérifier si window existe (SSR-safe)
    if (typeof window === 'undefined') {
      return;
    }

    setMounted(true);

    const mediaQuery = window.matchMedia(query);
    setMatches(mediaQuery.matches);

    const handler = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    // Utiliser addEventListener pour compatibilité
    mediaQuery.addEventListener("change", handler);

    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  }, [query]);

  // Retourner false pendant SSR pour éviter hydration mismatch
  if (!mounted) {
    return false;
  }

  return matches;
}
